import ApiRequest from "../util/ApiRequest";
// import GlobalData from "../util/GlobalData";

export default class Delivery {
    track = async (trackingNumber) => {
        return await ApiRequest.set(`/v1/deliveryServices/track-delivery?courier=pos&no_resi=${trackingNumber}`, "GET");
    }
}